import type { ChangelogEntry, ChangelogEntryMetadata } from '@/types/Changelog'

import Entry20260112, {
  metadata as metadata20260112,
} from '@/changelog/entries/2026-01-12-company-tracking.mdx'
import Entry20260126, {
  metadata as metadata20260126,
} from '@/changelog/entries/2026-01-26-prompts.mdx'
import Entry20260204, {
  metadata as metadata20260204,
} from '@/changelog/entries/2026-02-04-bookmarks.mdx'
import Entry20260209, {
  metadata as metadata20260209,
} from '@/changelog/entries/2026-02-09-ai-pursuit-tools.mdx'
import Entry20260219, {
  metadata as metadata20260219,
} from '@/changelog/entries/2026-02-19-action-confirmations.mdx'
import Entry20260223, {
  metadata as metadata20260223,
} from '@/changelog/entries/2026-02-23-pursuits-dashboard.mdx'
import Entry20260302, {
  metadata as metadata20260302,
} from '@/changelog/entries/2026-03-02-microsoft-365.mdx'
import Entry20260304, {
  metadata as metadata20260304,
} from '@/changelog/entries/2026-03-04-chat-experience.mdx'
import Entry20260309, {
  metadata as metadata20260309,
} from '@/changelog/entries/2026-03-09-usaspending.mdx'
import Entry20260528, {
  metadata as metadata20260528,
} from '@/changelog/entries/2026-05-28-multi-user-chats.mdx'
import Entry20260707, {
  metadata as metadata20260707,
} from '@/changelog/entries/2026-07-07-monitors.mdx'
import Entry20260715, {
  metadata as metadata20260715,
} from '@/changelog/entries/2026-07-15-market-intelligence.mdx'

const defineEntry = (
  id: string,
  Component: ChangelogEntry['Component'],
  metadata: ChangelogEntryMetadata,
): ChangelogEntry | null => {
  if (metadata.draft === true) {
    return null
  }

  return {
    id,
    title: metadata.title ?? id,
    published_at: metadata.published_at ?? id.slice(0, 10),
    summary: metadata.summary ?? null,
    tags: metadata.tags ?? [],
    Component,
  }
}

const entries = [
  defineEntry('2026-01-12-company-tracking', Entry20260112, metadata20260112),
  defineEntry('2026-01-26-prompts', Entry20260126, metadata20260126),
  defineEntry('2026-02-04-bookmarks', Entry20260204, metadata20260204),
  defineEntry('2026-02-09-ai-pursuit-tools', Entry20260209, metadata20260209),
  defineEntry(
    '2026-02-19-action-confirmations',
    Entry20260219,
    metadata20260219,
  ),
  defineEntry('2026-02-23-pursuits-dashboard', Entry20260223, metadata20260223),
  defineEntry('2026-03-02-microsoft-365', Entry20260302, metadata20260302),
  defineEntry('2026-03-04-chat-experience', Entry20260304, metadata20260304),
  defineEntry('2026-03-09-usaspending', Entry20260309, metadata20260309),
  defineEntry('2026-05-28-multi-user-chats', Entry20260528, metadata20260528),
  defineEntry('2026-07-07-monitors', Entry20260707, metadata20260707),
  defineEntry(
    '2026-07-15-market-intelligence',
    Entry20260715,
    metadata20260715,
  ),
].filter((entry): entry is ChangelogEntry => entry !== null)

export const changelogEntries = entries.toSorted((a, b) => {
  const byDate = b.published_at.localeCompare(a.published_at)
  if (byDate !== 0) return byDate
  return b.id.localeCompare(a.id)
})

export const latestChangelogEntry = changelogEntries[0] ?? null
